const PasswordRuleDescription = () => {
  return (
    <p
      className='text-[10px]'
      dangerouslySetInnerHTML={{
        __html:
          'パスワードは10文字以上で、少なくとも半角の英小文字、大文字、数字、および以下の記号のいずれか（!?@#$%^&*()-_=+{};:,<.>~）を含む必要があります。',
      }}
    />
  );
};

export { PasswordRuleDescription };
